import { useTheme } from "@mui/material";
import { useState, useEffect } from "react";
import { WorldRenderer } from "../../WorldRenderer";
import { WREvents } from "../../WREvents";
import { ScreePosUpdate } from "../physx/PhysXWorker";
import { ObjectLabel, ObjectLabelData } from "./ObjectLabel";

export function SceneInfoOverlay({ wr, size, position }: {
  wr: WorldRenderer,
  size: { width: number, height: number },
  position: { x: number, y: number }
}) {
  const theme = useTheme();
  const [labels, setLabels] = useState<ObjectLabelData[]>([]);

  useEffect(() => {
    const handleScreenPositionsUpdated = (changes: ScreePosUpdate[]) => {
      const labelsMap = new Map(labels.map(label => [label.visual._id, label]));
      // const changesMap = new Map(changes.map(change => [change._id, change]));
      for (const change of changes) {
        const existingLabel = labelsMap.get(change._id);
        if (existingLabel) {
          if (change.position) {
            // Update existing label position
            labelsMap.set(change._id, {
              ...existingLabel,
              screenPos: change.position,
            });
          } else {
            // Remove label if no position is provided
            labelsMap.delete(change._id);
          }
        } else if (wr.dataService.visuals.has(change._id) && change.position) {
          // Create new label
          const newLabel: ObjectLabelData = {
            visual: wr.dataService.visuals.get(change._id)!,
            screenPos: change.position,
          };
          labelsMap.set(change._id, newLabel);
        }
      }
      setLabels(Array.from(labelsMap.values()));
    };
    wr.on(WREvents.ScreenPositionsUpdated, handleScreenPositionsUpdated);
    return () => {
      wr.off(WREvents.ScreenPositionsUpdated, handleScreenPositionsUpdated);
    };
  }, [wr]);

  return (
    <div
      style={{
        position: "absolute",
        top: `${position.y}px`,
        left: `${position.x}px`,
        width: `${size.width}px`,
        height: `${size.height}px`,
        pointerEvents: "none",
        // backgroundColor: 'rgba(200, 0, 0, 0.5)',
      }}
    >
      {labels.map((label, index) => (
        <ObjectLabel key={label.visual._id} data={label} />
      ))}
    </div>
  );
}